export const TODO_PANEL_ANCHOR = '--todo-panel';
